export enum Columns {
  Actions = 'actions',
  Customers = 'customers',
  SubscriptionName = 'subscriptionName',
  SubscriptionType = 'subscriptionType',
  SubscriptionId = 'subscriptionId',
  Usage = 'usage',
  ValidTill = 'validTill',
}
